import { Callout } from "@octopusdeploy/design-system-components";
import { ActionExecutionLocation, GetPrimaryPackageReference } from "@octopusdeploy/octopus-server-client";
import { TargetRoles } from "~/areas/projects/components/Process/types";
import { TentaclePackageActionEdit } from "~/components/Actions/tentaclePackage/tentaclePackageAction";
import { BaseComponent } from "~/components/BaseComponent/BaseComponent";
import { DisplayFeedName } from "../DisplayFeedName";
import Roles from "../Roles";
import type { ActionSummaryProps } from "../actionSummaryProps";
import pluginRegistry from "../pluginRegistry";
interface WindowsServiceActionSummaryState {
    feedName: string;
}
class WindowsServiceActionSummary extends BaseComponent<ActionSummaryProps, WindowsServiceActionSummaryState> {
    constructor(props: ActionSummaryProps) {
        super(props);
    }
    render() {
        const pkg = GetPrimaryPackageReference(this.props.packages);
        return pkg ? (<div>
                {"Deploy Windows Service using package"} <strong> {pkg.PackageId} </strong> {"from"} <DisplayFeedName pkg={pkg}/>
                {this.props.targetRolesAsCSV && (<span>
                        {" "}
                        to deployment targets with <Roles rolesAsCSV={this.props.targetRolesAsCSV}/>{" "}
                    </span>)}
            </div>) : (<Callout type={"warning"} title="Misconfigured step">
                Package was not selected or cannot be found. Please review this step and ensure a valid package is selected.
            </Callout>);
    }
    static displayName = "WindowsServiceActionSummary";
}
pluginRegistry.registerAction({
    executionLocation: ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WindowsService",
    summary: (properties, targetRolesAsCSV, packages) => <WindowsServiceActionSummary properties={properties} packages={packages} targetRolesAsCSV={targetRolesAsCSV}/>,
    editSections: { default: TentaclePackageActionEdit },
    canHaveChildren: (step) => true,
    canBeChild: true,
    targetRoleOption: (action) => TargetRoles.Optional,
    hasPackages: (action) => true,
    features: {
        permanent: ["Octopus.Features.WindowsService"],
        optional: [
            "Octopus.Features.ConfigurationTransforms",
            "Octopus.Features.ConfigurationVariables",
            "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles",
            "Octopus.Features.SelectPowerShellEditionForWindows",
        ],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"],
    },
    docsLink: "deployWindowsServices",
    createInitialInputs: (initialInputsBuilder) => ({
        packages: initialInputsBuilder.initializePackages(),
    }),
});
